import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _60dd54f8 = () => interopDefault(import('../../../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _8d896858 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _3073f622 = () => interopDefault(import('../../../pages/courses/index.vue' /* webpackChunkName: "pages/courses/index" */))
const _0927dbb1 = () => interopDefault(import('../../../pages/about/flashcards.vue' /* webpackChunkName: "pages/about/flashcards" */))
const _4708332c = () => interopDefault(import('../../../pages/about/immersive-reading.vue' /* webpackChunkName: "pages/about/immersive-reading" */))
const _ad08d998 = () => interopDefault(import('../../../pages/about/mobile-app.vue' /* webpackChunkName: "pages/about/mobile-app" */))
const _790ea6ba = () => interopDefault(import('../../../pages/about/privacy.vue' /* webpackChunkName: "pages/about/privacy" */))
const _798f13b9 = () => interopDefault(import('../../../pages/about/terms.vue' /* webpackChunkName: "pages/about/terms" */))
const _3d66403b = () => interopDefault(import('../../../pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _871a60b0 = () => interopDefault(import('../../../pages/account/logout.vue' /* webpackChunkName: "pages/account/logout" */))
const _7803f3fb = () => interopDefault(import('../../../pages/account/profile.vue' /* webpackChunkName: "pages/account/profile" */))
const _c6cb99d2 = () => interopDefault(import('../../../pages/account/verify.vue' /* webpackChunkName: "pages/account/verify" */))
const _f3178ec4 = () => interopDefault(import('../../../pages/admin/books.vue' /* webpackChunkName: "pages/admin/books" */))
const _04ff48a8 = () => interopDefault(import('../../../pages/admin/courses.vue' /* webpackChunkName: "pages/admin/courses" */))
const _09f73faf = () => interopDefault(import('../../../pages/admin/flashcards.vue' /* webpackChunkName: "pages/admin/flashcards" */))
const _11066d69 = () => interopDefault(import('../../../pages/admin/payments.vue' /* webpackChunkName: "pages/admin/payments" */))
const _69d7ec9a = () => interopDefault(import('../../../pages/admin/user-access.vue' /* webpackChunkName: "pages/admin/user-access" */))
const _c6c96fda = () => interopDefault(import('../../../pages/courses/bahai_arabic_immersion-en_ar.vue' /* webpackChunkName: "pages/courses/bahai_arabic_immersion-en_ar" */))
const _700a99b1 = () => interopDefault(import('../../../pages/courses/bahai_farsi_introduction-en_fa.vue' /* webpackChunkName: "pages/courses/bahai_farsi_introduction-en_fa" */))
const _4570e236 = () => interopDefault(import('../../../pages/courses/farsi_deep_dive-en_fa.vue' /* webpackChunkName: "pages/courses/farsi_deep_dive-en_fa" */))
const _2fd4b9ba = () => interopDefault(import('../../../pages/courses/farsi_immersion-en_fa.vue' /* webpackChunkName: "pages/courses/farsi_immersion-en_fa" */))
const _7861e6b6 = () => interopDefault(import('../../../pages/courses/magic_spanish-en_es.vue' /* webpackChunkName: "pages/courses/magic_spanish-en_es" */))
const _efb50796 = () => interopDefault(import('../../../pages/courses/military_arabic-en_ar.vue' /* webpackChunkName: "pages/courses/military_arabic-en_ar" */))
const _1924861e = () => interopDefault(import('../../../pages/courses/military_immersion_farsi-en_fa.vue' /* webpackChunkName: "pages/courses/military_immersion_farsi-en_fa" */))
const _69449eb9 = () => interopDefault(import('../../../pages/courses/romance_arabic-en_ar.vue' /* webpackChunkName: "pages/courses/romance_arabic-en_ar" */))
const _2d83fdb0 = () => interopDefault(import('../../../pages/user/account/index.vue' /* webpackChunkName: "pages/user/account/index" */))
const _8f6a0d54 = () => interopDefault(import('../../../pages/user/course/index.vue' /* webpackChunkName: "pages/user/course/index" */))
const _e6da032a = () => interopDefault(import('../../../pages/user/flashcards.vue' /* webpackChunkName: "pages/user/flashcards" */))
const _5ab54236 = () => interopDefault(import('../../../pages/user/library/index.vue' /* webpackChunkName: "pages/user/library/index" */))
const _e98b3202 = () => interopDefault(import('../../../pages/user/account/profile.vue' /* webpackChunkName: "pages/user/account/profile" */))
const _2cb561c1 = () => interopDefault(import('../../../pages/admin/editcourse/_key/index.vue' /* webpackChunkName: "pages/admin/editcourse/_key/index" */))
const _2fe7c4d9 = () => interopDefault(import('../../../pages/user/course/_courseid.vue' /* webpackChunkName: "pages/user/course/_courseid" */))
const _5fa914c7 = () => interopDefault(import('../../../pages/user/library/_bookid.vue' /* webpackChunkName: "pages/user/library/_bookid" */))
const _0dbe598e = () => interopDefault(import('../../../pages/admin/editbook/_key/edit.vue' /* webpackChunkName: "pages/admin/editbook/_key/edit" */))
const _31b7720e = () => interopDefault(import('../../../pages/admin/editbook/_key/print.vue' /* webpackChunkName: "pages/admin/editbook/_key/print" */))
const _7de21a58 = () => interopDefault(import('../../../pages/book/_bid.vue' /* webpackChunkName: "pages/book/_bid" */))
const _39f9ab43 = () => interopDefault(import('../../../pages/study/_courseid.vue' /* webpackChunkName: "pages/study/_courseid" */))
const _20c9a685 = () => interopDefault(import('../../../pages/courses/_courseid/signup.vue' /* webpackChunkName: "pages/courses/_courseid/signup" */))
const _f1ff82f4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _60dd54f8,
    name: "about"
  }, {
    path: "/contact",
    component: _8d896858,
    name: "contact"
  }, {
    path: "/courses",
    component: _3073f622,
    name: "courses"
  }, {
    path: "/about/flashcards",
    component: _0927dbb1,
    name: "about-flashcards"
  }, {
    path: "/about/immersive-reading",
    component: _4708332c,
    name: "about-immersive-reading"
  }, {
    path: "/about/mobile-app",
    component: _ad08d998,
    name: "about-mobile-app"
  }, {
    path: "/about/privacy",
    component: _790ea6ba,
    name: "about-privacy"
  }, {
    path: "/about/terms",
    component: _798f13b9,
    name: "about-terms"
  }, {
    path: "/account/login",
    component: _3d66403b,
    name: "account-login"
  }, {
    path: "/account/logout",
    component: _871a60b0,
    name: "account-logout"
  }, {
    path: "/account/profile",
    component: _7803f3fb,
    name: "account-profile"
  }, {
    path: "/account/verify",
    component: _c6cb99d2,
    name: "account-verify"
  }, {
    path: "/admin/books",
    component: _f3178ec4,
    name: "admin-books"
  }, {
    path: "/admin/courses",
    component: _04ff48a8,
    name: "admin-courses"
  }, {
    path: "/admin/flashcards",
    component: _09f73faf,
    name: "admin-flashcards"
  }, {
    path: "/admin/payments",
    component: _11066d69,
    name: "admin-payments"
  }, {
    path: "/admin/user-access",
    component: _69d7ec9a,
    name: "admin-user-access"
  }, {
    path: "/courses/bahai_arabic_immersion-en_ar",
    component: _c6c96fda,
    name: "courses-bahai_arabic_immersion-en_ar"
  }, {
    path: "/courses/bahai_farsi_introduction-en_fa",
    component: _700a99b1,
    name: "courses-bahai_farsi_introduction-en_fa"
  }, {
    path: "/courses/farsi_deep_dive-en_fa",
    component: _4570e236,
    name: "courses-farsi_deep_dive-en_fa"
  }, {
    path: "/courses/farsi_immersion-en_fa",
    component: _2fd4b9ba,
    name: "courses-farsi_immersion-en_fa"
  }, {
    path: "/courses/magic_spanish-en_es",
    component: _7861e6b6,
    name: "courses-magic_spanish-en_es"
  }, {
    path: "/courses/military_arabic-en_ar",
    component: _efb50796,
    name: "courses-military_arabic-en_ar"
  }, {
    path: "/courses/military_immersion_farsi-en_fa",
    component: _1924861e,
    name: "courses-military_immersion_farsi-en_fa"
  }, {
    path: "/courses/romance_arabic-en_ar",
    component: _69449eb9,
    name: "courses-romance_arabic-en_ar"
  }, {
    path: "/user/account",
    component: _2d83fdb0,
    name: "user-account"
  }, {
    path: "/user/course",
    component: _8f6a0d54,
    name: "user-course"
  }, {
    path: "/user/flashcards",
    component: _e6da032a,
    name: "user-flashcards"
  }, {
    path: "/user/library",
    component: _5ab54236,
    name: "user-library"
  }, {
    path: "/user/account/profile",
    component: _e98b3202,
    name: "user-account-profile"
  }, {
    path: "/admin/editcourse/:key",
    component: _2cb561c1,
    name: "admin-editcourse-key"
  }, {
    path: "/user/course/:courseid",
    component: _2fe7c4d9,
    name: "user-course-courseid"
  }, {
    path: "/user/library/:bookid",
    component: _5fa914c7,
    name: "user-library-bookid"
  }, {
    path: "/admin/editbook/:key?/edit",
    component: _0dbe598e,
    name: "admin-editbook-key-edit"
  }, {
    path: "/admin/editbook/:key?/print",
    component: _31b7720e,
    name: "admin-editbook-key-print"
  }, {
    path: "/book/:bid?",
    component: _7de21a58,
    name: "book-bid"
  }, {
    path: "/study/:courseid?",
    component: _39f9ab43,
    name: "study-courseid"
  }, {
    path: "/courses/:courseid/signup",
    component: _20c9a685,
    name: "courses-courseid-signup"
  }, {
    path: "/",
    component: _f1ff82f4,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
